import { PlanSlug } from './planSlugs'

const planNames = {
  [PlanSlug.SCAN_LITE]: 'Virtual Office London',
  [PlanSlug.SCAN_PRO]: 'Virtual Office London (Mail forwarding)',
  [PlanSlug.PHONE]: 'WhatsApp for Business Number',
}

export default planNames
